import React from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CategoryIcon } from "./CategoryIcon";
import { QuestionItem } from "./QuestionItem";
import { GroupedQuestion } from "./types";

type AllCategoriesViewProps = {
  categories: GroupedQuestion[];
  onClose: () => void;
  onSelectQuestion: (question: string) => void;
};

export const AllCategoriesView = ({
  categories,
  onClose,
  onSelectQuestion,
}: AllCategoriesViewProps) => (
  <div className="bg-white rounded-lg border border-gray-200 shadow-lg mt-6">
    <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
      <h2 className="text-sm font-semibold">Use Cases</h2>
      <Button
        onClick={onClose}
        className="p-1 text-[#000000d9] transition-colors border-0 shadow-none"
        icon={<CloseOutlined />}
        aria-label="Close all categories view"
      />
    </div>
    <div className="max-h-[calc(100vh-400px)] space-y-6 overflow-y-auto p-4 hide-scrollbar">
      {categories.map((category) => (
        <div key={category.key}>
          <h3 className="font-semibold text-[#064C68] flex items-center gap-2">
            <CategoryIcon category={category.key} />
            {category.key.toUpperCase()}
          </h3>
          <div className="py-3 space-y-2">
            {category.values.map((question) => (
              <QuestionItem
                key={question.id}
                question={question}
                onSelect={onSelectQuestion}
                className="w-full text-left  p-3 bg-[#00000005] rounded-lg border border-[#0000001f] hover:bg-gray-100 transition-colors cursor-pointer"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);
